import { CreditRisk } from '@types';
import { moneyFormatter } from '@utils';
import cls from './CreditBureau.module.css';


interface Props {
  risk: CreditRisk;
  title?: string;
}

interface TableRowProps {
  title: string;
  value: number;
  type: 'money' | 'percent' | 'number';
}

const Table = ({ rows }: { rows: TableRowProps[] }) => (
  <div className={cls.table}>
    {rows.map((i: TableRowProps, idx) => (
      <div className={cls.line} key={idx}>
        <div className={cls.label}>{i.title}</div>
        <div className={cls.value}>
          {i.type === 'percent' ? (`${i.value}%`) : null}
          {i.type === 'number' ? i.value : null}
          {i.type === 'money' ? moneyFormatter.format(i.value) : null}
        </div>
      </div>))}
  </div>
);

export const CreditBureauTables = ({ risk, title }: Props) => {
  const { creditBureau } = risk;
  const table1: TableRowProps[] = [
    { title: 'Total Credits', value: (creditBureau?.rows || []).length, type: 'number' },
    { title: 'Total Amount', value: creditBureau?.total?.totalAmount, type: 'money' },
    { title: 'Capital Balance', value: creditBureau?.total?.capitalBalance, type: 'money' },
    { title: 'Overdue Balance', value: creditBureau?.total?.overdueBalance, type: 'money' },
    { title: 'Monthly Payment', value: creditBureau?.total?.monthlyPayment, type: 'money' },
    { title: 'Late Payment', value: creditBureau?.total?.latePayment, type: 'money' },
    { title: 'Total Payment', value: creditBureau?.total?.totalPayment, type: 'money' },
  ];
  const table2: TableRowProps[] = [
    { title: 'Annual Revenue', value: creditBureau?.annualRevenue, type: 'money' },
    { title: 'Monthly Sales Revenue', value: creditBureau?.monthlySalesRevenue, type: 'money' },
    { title: 'NOI Rate', value: creditBureau?.noiRate, type: 'percent' },
    { title: 'Monthly NOI', value: creditBureau?.monthlyNoi, type: 'money' },
    { title: '# Invoices', value: creditBureau?.invoices, type: 'number' },
    { title: 'AVG Invoice', value: creditBureau?.avgInvoice, type: 'money' },
    { title: 'Guarantee Suggestion', value: creditBureau?.guaranteeSuggestion, type: 'money' },
  ];

  return (
    <div className={cls.wrap}>
      <div className={cls.title}>
        {title ? title : 'Credit Bureau'}
      </div>
      <div className={cls.row}>
        <div className={cls.col}>
          <Table rows={table1} />
        </div>
        <div className={cls.col}>
          <Table rows={table2} />
        </div>
      </div>
    </div>
  );
};
